module.exports = __webpack_public_path__ + "static/media/zrx.4f863f26.svg";